<template>
  <div class="product-info">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/productCenter' }">{{ $t('productCenter.breadcrumbProductCenter') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('productCenter.breadcrumbProductInfo') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="info-content">
      <div class="content-tabs">
        <div 
          class="content-tabs-item" 
          v-for="item in tabsList" 
          :key="item.value"
          :class="{'current': currentIndex === item.value}"
          @click="tabClick(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="info-item">
      <div class="tabs-content">
        <h2>{{ $t('productCenter.productDetail') }}</h2>
      </div>
      <product1 v-if="currentIndex === '1'"></product1>
      <product2 v-if="currentIndex === '2'"></product2>
      <product3 v-if="currentIndex === '3'"></product3>
      <product4 v-if="currentIndex === '4'"></product4>
      <product5 v-if="currentIndex === '5'"></product5>
      <product6 v-if="currentIndex === '6'"></product6>
      <product7 v-if="currentIndex === '7'"></product7>
      <product8 v-if="currentIndex === '8'"></product8>
      <product9 v-if="currentIndex === '9'"></product9>
      <product10 v-if="currentIndex === '10'"></product10>
      <product11 v-if="currentIndex === '11'"></product11>
      <product12 v-if="currentIndex === '12'"></product12>
    </div>

  </div>
</template>

<script>
import product1 from './components/product1.vue'
import product2 from './components/product2.vue'
import product3 from './components/product3.vue'
import product4 from './components/product4.vue'
import product5 from './components/product5.vue'
import product6 from './components/product6.vue'
import product7 from './components/product7.vue'
import product8 from './components/product8.vue'
import product9 from './components/product9.vue'
import product10 from './components/product10.vue'
import product11 from './components/product11.vue'
import product12 from './components/product12.vue'
export default {
  data () {
    return {
      currentIndex: '1'
    }
  },
  computed: {
    tabsList() {
      return [
        { label: this.$t('productCenter.tabs.hpcm'), value: '1' },
        { label: this.$t('productCenter.tabs.hgp'), value: '2' },
        { label: this.$t('productCenter.tabs.hgpPt'), value: '3' },
        { label: this.$t('productCenter.tabs.hg'), value: '4' },
        { label: this.$t('productCenter.tabs.hf'), value: '5' },
        { label: this.$t('productCenter.tabs.hgr'), value: '6' },
        { label: this.$t('productCenter.tabs.hi'), value: '7' },
        { label: this.$t('productCenter.tabs.htb'), value: '8' },
        { label: this.$t('productCenter.tabs.hlm'), value: '9' },
        { label: this.$t('productCenter.tabs.ahi'), value: '10' },
        { label: this.$t('productCenter.tabs.ahiFoam'), value: '11' },
        { label: this.$t('productCenter.tabs.nanoBoard'), value: '12' },
      ]
    }
  },
  methods: {
    tabClick (value) {
      this.currentIndex = value
    },
  },
  components: {
    product1,
    product2,
    product3,
    product4,
    product5,
    product6,
    product7,
    product8,
    product9,
    product10,
    product11,
    product12
  }
}
</script>

<style lang="scss" scoped>
.product-info {
  padding-top: 60px;
  
  margin: 0 auto;
  .el-breadcrumb {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;
  }
  .info-content {
    padding: 45px 0;
    background: rgba(249, 249, 249, 1);
  }
  .content-tabs {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .content-tabs-item {
      padding: 14px 32px;
      color: #333;
      border-radius: 32px 32px 32px 32px;
      background-color: rgb(240, 240, 240);
      margin: 8px;
      cursor: pointer;
      &.current {
        color: #fff;
        background-color: rgb(28, 100, 215);
      }
    }
  }
  .info-item {
    margin: 0 auto;
    .tabs-content {
      width: 1200px;
      margin: 0 auto;
      padding-top: 60px;
      padding-bottom: 40px;
      h2 {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
      }
    }
  }
}
</style>